import { Box, Text } from '@chakra-ui/react';
import { Form, TreeSelect } from 'antd';
import React from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import Styles from '../SellYourCarForm.module.scss';

interface OptionType {
  name: string;
  value: string;
}

interface VehicleBasicInfoStepProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  name: string;
  options: OptionType[];
  placeholder: string;
  errorMessage: string;
}

const VehicleBasicInfoStep: React.FC<VehicleBasicInfoStepProps> = ({
  control,
  errors,
  name,
  options,
  placeholder,
  errorMessage,
}) => {
  return (
    <Box mb={{ sm: '50px' }}>
      <Controller
        name={name}
        control={control}
        rules={{ required: errorMessage }}
        render={({ field }) => {
          return (
            <Form.Item label="" className={Styles.formLabel} layout="vertical">
              <TreeSelect
                {...field}
                className={Styles.formInput}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder={placeholder}
                treeData={options.map((option) => ({
                  title: option.name,
                  value: option.value,
                  key: option.value,
                }))}
                showSearch
                allowClear
              />
            </Form.Item>
          );
        }}
      />
      {errors[name] && (
        <Text color="red.500" fontSize="sm">
          {errors[name]?.message?.toString() || errorMessage}
        </Text>
      )}
    </Box>
  );
};

export default VehicleBasicInfoStep;
